module.exports = __webpack_public_path__ + "static/media/buildPresentation.81081870.gif";